/**
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 */

import axios from '../utils/axios'

export function getUserInfo() {
  return axios.get('/user/info');
}

export function EditUserInfo(params) {
  return axios.put('/user/info', params);
}

export function login(params) {
  return axios.post('/site/login', params);
}

export function logout() {
  return axios.post('/user/logout')
}

export function register(params) {
  return axios.post('/user/register', params);
}
//意见反馈列表
export function getOpinion(params) {
  return axios.get(`/member/opinion?page=${params}`);
}
//提交意见
export function opinionList(params) {
  return axios.post('/member/opinion', params);
}
//上传文件
export function upload(params) {
  return axios.post('/image/upload', params);
}
//修改密码
export function changePassword(params) {
  return axios.post('/site/up-pwd', params);
}
//个人信息
export function getMemberInfo(params) {
  return axios.get('/member/member/index', params);
}
//微信授权登录
export function wechatLogin(params) {
  return axios.post('/site/OfficialAccountApi', params);
}
